import { Injectable } from '@angular/core';
import { filter, map, Observable } from 'rxjs';
import { System } from '../../app/core/resources/system';
import { DocumentCollection } from 'ngx-jsonapi';
import { SystemsService } from '../../app/core/services/systems.service';
import { NetworkService } from '@app/core/services/network.service';
@Injectable({
    providedIn: 'root'
})
export class SearchSystemUseCase {
    public constructor(public networkService: NetworkService, private systemsService: SystemsService) {}

    public execute(systemIds: Array<string>): Observable<Array<System>> {
        return this.systemsService.all({ include: ['rates', 'currency', 'system_information', 'networks'], ttl: 0 }).pipe(
            filter((systems: DocumentCollection<System>) => {
                return systems.source !== 'new';
            }),
            map((systems: DocumentCollection<System>) => {
                return systems.data.filter((system: System) => {
                    return systemIds.includes(system.id);
                });
            })
        );
    }
}
